import React, { Fragment } from "react";
import { compose } from "redux";
import { translate } from "react-i18next";
import {
  CHART_LAYOUT_MODE,
  getAllChartLayoutAnnotations,
  getLayoutAnnotationDefaultChartLayout,
  getLayoutAnnotationGraphLockedDims,
  setLayoutAnnotationDefaultChartLayout,
  setLayoutAnnotationGraphLockedDims
} from "../../utils/annotations";
import { Card, Checkbox, Col, Form, Radio, Row, Select, Tag } from "antd";
import _, { isEqual } from "lodash";
import { GUTTER_MD, GUTTER_SM, MARGIN_MD, MARGIN_SM, PADDING_MD, SPAN_FULL, SPAN_HALF } from "../../styles/constants";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import DragHandle from "../drag-handle";
import CustomEmpty from "../custom-empty";
import "./style.css";
import DefaultFiltersModal from "./default-filter-modal/DefaultFiltersModal";

const DROPPABLE_ID_PRIMARY_DIM = 'primaryDim';
const DROPPABLE_ID_SECONDARY_DIM = 'secondaryDim';
const DROPPABLE_ID_FILTER = 'filter';


const getLayoutAnnotationConfig = (layoutAnnotations, annotationsConfig, chartLayoutMode) => ({
  defaultChartLayout: getLayoutAnnotationDefaultChartLayout(layoutAnnotations, annotationsConfig, chartLayoutMode),
  graphLockedDims: getLayoutAnnotationGraphLockedDims(layoutAnnotations, annotationsConfig, chartLayoutMode)
})

const chartLayoutMode = CHART_LAYOUT_MODE.cartesian
class DefaultChartLayout extends React.Component {

  constructor(props) {
    super(props);
    const allChartLayoutAnnotations = getAllChartLayoutAnnotations(this.props.layoutAnnotations, this.props.annotationsConfig)

    this.state = {
      chartLayoutMode,
      flagSaveAnnotation: !!allChartLayoutAnnotations.length,
      [CHART_LAYOUT_MODE.cartesian]: {
        primaryDim: [],
        secondaryDim: [],
        filter: [],
        lockedDims: [],
        filterDefaultValues: []
      },
      [CHART_LAYOUT_MODE.radial]: {
        primaryDim: [],
        secondaryDim: [],
        filter: [],
        lockedDims: [],
        filterDefaultValues: []
      },
    };

    this.getDefaultLayout = this.getDefaultLayout.bind(this);
    this.onFlagSaveAnnotationChange = this.onFlagSaveAnnotationChange.bind(this);

    this.onLockedDimsChange = this.onLockedDimsChange.bind(this);
  }

  componentDidMount() {
    const { graphLockedDims: cartesianGraphLockedDims, defaultChartLayout: cartesianChartLayout } = getLayoutAnnotationConfig(this.props.layoutAnnotations, this.props.annotationsConfig, CHART_LAYOUT_MODE.cartesian)
    const { graphLockedDims: radialGraphLockedDims, defaultChartLayout: radialChartLayout } = getLayoutAnnotationConfig(this.props.layoutAnnotations, this.props.annotationsConfig, CHART_LAYOUT_MODE.radial)

    this.setState({
      [CHART_LAYOUT_MODE.cartesian]: {
        ...(cartesianChartLayout || this.getDefaultLayout()),
        lockedDims: cartesianGraphLockedDims
      },
      [CHART_LAYOUT_MODE.radial]: {
        ...(radialChartLayout || this.getDefaultLayout()),
        lockedDims: radialGraphLockedDims
      }
    })
  }

  static getDerivedStateFromProps(props, state) {
    if (props.dsdDimensions) {

      const {
        primaryDim,
        secondaryDim,
        filter,
        lockedDims,
        filterDefaultValues
      } = state[state.chartLayoutMode];

      const newFilter = [
        ...filter.filter(id => props.dsdDimensions.find(dim => dim.id === id)),
        ...props.dsdDimensions
          .filter(dim => ![...primaryDim, ...secondaryDim, ...filter].find(id => id === dim.id))
          .map(({ id }) => id)
      ]

      return ({
        [state.chartLayoutMode]: {
          primaryDim: primaryDim.filter(id => props.dsdDimensions.find(dim => dim.id === id)),
          secondaryDim: secondaryDim.filter(id => props.dsdDimensions.find(dim => dim.id === id)),
          filter: newFilter,
          filterDefaultValues: _.pickBy(filterDefaultValues, function (value, key) {
            return newFilter.find(id => id === key);
          }),
          lockedDims: lockedDims.filter(id => props.dsdDimensions.find(dim => dim.id === id))
        }
      });
    } else {
      return null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevState[this.state.chartLayoutMode], this.state[this.state.chartLayoutMode])) {
      this.updateChartLayout()
    }
    if (prevState.flagSaveAnnotation !== this.state.flagSaveAnnotation) {
      if (this.state.flagSaveAnnotation) {
        this.updateChartLayout()
      } else {
        let layoutAnnotations = _.cloneDeep(this.props.layoutAnnotations);

        layoutAnnotations = setLayoutAnnotationDefaultChartLayout(
          layoutAnnotations,
          this.props.annotationsConfig,
          null,
          null
        );
        layoutAnnotations = setLayoutAnnotationGraphLockedDims(
          layoutAnnotations,
          this.props.annotationsConfig,
          null,
          chartLayoutMode
        );
        this.props.onChange({ layoutAnnotations });
      }
    }
    if (prevState.chartLayoutMode !== this.state.chartLayoutMode) {
      const { graphLockedDims, defaultChartLayout } = getLayoutAnnotationConfig(this.props.layoutAnnotations, this.props.annotationsConfig, this.state.chartLayoutMode)
      const {
        primaryDim,
        secondaryDim,
        filter,
        filterDefaultValues
      } = defaultChartLayout || this.getDefaultLayout()

      this.setState({
        [this.state.chartLayoutMode]: {
          lockedDims: graphLockedDims,
          primaryDim,
          secondaryDim,
          filter,
          filterDefaultValues
        }
      })
    }
    if (this.props.dsdDimensions && (!prevProps.dsdDimensions || this.props.dsdDimensions.length !== prevProps.dsdDimensions.length)) {
      if (this.state.flagSaveAnnotation) {
        const {
          primaryDim,
          secondaryDim,
          filter,
          lockedDims,
          filterDefaultValues
        } = this.state[this.state.chartLayoutMode];

        const newFilter = [
          ...filter.filter(id => this.props.dsdDimensions.find(dim => dim.id === id)),
          ...this.props.dsdDimensions
            .filter(dim => ![...primaryDim, ...secondaryDim, ...filter].find(id => id === dim.id))
            .map(({ id }) => id)
        ]

        let layoutAnnotations = _.cloneDeep(this.props.layoutAnnotations);

        layoutAnnotations = setLayoutAnnotationDefaultChartLayout(
          layoutAnnotations,
          this.props.annotationsConfig,
          {
            primaryDim: primaryDim.filter(id => this.props.dsdDimensions.find(dim => dim.id === id)),
            secondaryDim: secondaryDim.filter(id => this.props.dsdDimensions.find(dim => dim.id === id)),
            filter: newFilter,
            filterDefaultValues: _.pickBy(filterDefaultValues, function (value, key) {
              return newFilter.find(id => id === key);
            })
          },
          this.state.chartLayoutMode
        );

        layoutAnnotations = setLayoutAnnotationGraphLockedDims(
          layoutAnnotations,
          this.props.annotationsConfig,
          lockedDims,
          this.state.chartLayoutMode
        );

        this.props.onChange({ layoutAnnotations });
      }
    }

  }

  updateChartLayout() {
    const { lockedDims: cartesianLockedDims, ...cartesianDims } = this.state[CHART_LAYOUT_MODE.cartesian]
    const { lockedDims: radialLockedDims, ...radialDims } = this.state[CHART_LAYOUT_MODE.radial]

    if (this.state.flagSaveAnnotation) {
      let layoutAnnotations = _.cloneDeep(this.props.layoutAnnotations);
      layoutAnnotations = setLayoutAnnotationDefaultChartLayout(
        layoutAnnotations,
        this.props.annotationsConfig,
        cartesianDims,
        CHART_LAYOUT_MODE.cartesian
      );
      layoutAnnotations = setLayoutAnnotationDefaultChartLayout(
        layoutAnnotations,
        this.props.annotationsConfig,
        radialDims,
        CHART_LAYOUT_MODE.radial
      );
      layoutAnnotations = setLayoutAnnotationGraphLockedDims(
        layoutAnnotations,
        this.props.annotationsConfig,
        cartesianLockedDims,
        CHART_LAYOUT_MODE.cartesian
      );
      layoutAnnotations = setLayoutAnnotationGraphLockedDims(
        layoutAnnotations,
        this.props.annotationsConfig,
        radialLockedDims,
        CHART_LAYOUT_MODE.radial
      );
      this.props.onChange({ layoutAnnotations });
    }
  }

  getDefaultLayout() {
    const TIME_PERIOD_KEY = "TIME_PERIOD";

    const dims = this.props.dsdDimensions.map(({ id }) => id);
    const primaryDim = dims.includes(TIME_PERIOD_KEY)
      ? [TIME_PERIOD_KEY]
      : dims.slice(0, 1);

    return ({
      primaryDim: primaryDim,
      secondaryDim: [],
      filter: this.props.dsdDimensions
        .sort((a, b) =>
          a.order && b.order && a.order !== b.order
            ? a.order - b.order
            : a.id - b.id
        )
        .map(({ id }) => id)
        .filter(id => !primaryDim.includes(id)),
      filterDefaultValues: {}
    });
  }

  onFlagSaveAnnotationChange(checked) {
    this.setState({
      flagSaveAnnotation: checked
    });
  }


  onDragEnd(source, destination) {
    const reorder = (list, startIndex, endIndex) => {
      const [removed] = list.splice(startIndex, 1);
      list.splice(endIndex, 0, removed);
    };

    const move = (source, destination, droppableSource, droppableDestination) => {
      const [removed] = source.splice(droppableSource.index, 1);
      destination.splice(droppableDestination.index, 0, removed);
    };

    const swap = (sourceArr, destinationArr, droppableSource) => {
      const [removedSrc] = sourceArr.splice(droppableSource.index, 1);
      const [removedDst] = destinationArr.splice(0, 1, removedSrc);
      sourceArr.splice(sourceArr.length, 0, removedDst);
    };

    if (source && destination) {
      const state = this.state[this.state.chartLayoutMode]

      const newLayout = {
        primaryDim: [...state.primaryDim],
        secondaryDim: [...state.secondaryDim],
        filter: [...state.filter],
        filterDefaultValues: { ...state.filterDefaultValues },
        lockedDims: [...state.lockedDims]
      };

      // When a dimension is dragged out of the filter card, the default value is eliminated
      if (source.droppableId === DROPPABLE_ID_FILTER && destination.droppableId !== DROPPABLE_ID_FILTER)
        delete newLayout.filterDefaultValues[state.filter[source.index]]

      if (source.droppableId === destination.droppableId) {
        reorder(
          newLayout[source.droppableId],
          source.index,
          destination.index
        );

      } else if (
        (source.droppableId === DROPPABLE_ID_SECONDARY_DIM && destination.droppableId === DROPPABLE_ID_FILTER) ||
        (source.droppableId === DROPPABLE_ID_FILTER && destination.droppableId === DROPPABLE_ID_SECONDARY_DIM && newLayout[destination.droppableId].length === 0)
      ) {
        move(
          newLayout[source.droppableId],
          newLayout[destination.droppableId],
          source,
          destination
        );

      } else {
        swap(
          newLayout[source.droppableId],
          newLayout[destination.droppableId],
          source
        );
      }

      this.setState({
        [this.state.chartLayoutMode]: {
          ...newLayout
        },
        flagSaveAnnotation: true
      });
    }
  }

  onLockedDimsChange(lockedDims) {
    this.setState({
      [this.state.chartLayoutMode]: {
        ...this.state[this.state.chartLayoutMode],
        lockedDims: lockedDims
      },
      flagSaveAnnotation: true
    });
  }

  render() {
    const {
      t,
      disabled,
      dsdDimensions,
    } = this.props;

    const {
      flagSaveAnnotation,
      chartLayoutMode,
    } = this.state;

    const {
      primaryDim,
      secondaryDim,
      filter,
      lockedDims,
      filterDefaultValues
    } = this.state[chartLayoutMode]

    const Dimension = ({ id, index, isDragDisabled, defaultValue }) => {
      return (
        <Draggable draggableId={id} index={index} isDragDisabled={isDragDisabled}>
          {provided => (
            <div ref={provided.innerRef} {...provided.draggableProps}>
              <Row type="flex" style={{ marginBottom: MARGIN_SM }}>
                <Col span={SPAN_FULL}>
                  <Tag
                    style={{
                      width: "100%",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis"
                    }}
                    title={defaultValue ? (id + "=" + defaultValue) : (id)}
                  >
                    {!isDragDisabled
                      ? (
                        <span {...provided.dragHandleProps}>
                          <DragHandle />
                        </span>
                      )
                      : null
                    }
                    {defaultValue ? (id + "=" + defaultValue) : (id)}
                  </Tag>
                </Col>
              </Row>
            </div>
          )}
        </Draggable>
      )
    };

    const cardStyle = {
      height: "100%",
    };

    const cardBodyStyle = {
      position: "relative",
      padding: 0,
    };

    const droppableStyle = {
      position: "absolute",
      height: "100%",
      width: "100%",
      padding: PADDING_MD,
      overflowY: "auto",
      overflowX: "hidden"
    };

    const filterCard =
      <Card
        className="cardHeaderButton"
        type="inner"
        title={t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.filter.title")}
        style={{ ...cardStyle }}
        bodyStyle={{ ...cardBodyStyle, minHeight: 297 }}
        extra={
          <DefaultFiltersModal
            filter={filter}
            filterDefaultValues={filterDefaultValues}
            onChange={
              (filterDict) => {
                const layoutAnnotations = setLayoutAnnotationDefaultChartLayout(
                  _.cloneDeep(this.props.layoutAnnotations),
                  this.props.annotationsConfig,
                  {
                    primaryDim,
                    secondaryDim,
                    filter,
                    filterDefaultValues: filterDict
                  },
                  chartLayoutMode
                )
                
                this.props.onChange({ layoutAnnotations })
                this.setState({ ...this.state, [this.state.chartLayoutMode]: { ...this.state[this.state.chartLayoutMode], filterDefaultValues: filterDict } })
              }

            }
            dsdDimensions={dsdDimensions}
            cubeId={this.props.cubeId}
            dataflowColumns={this.props.colNames}
            dataflowFilterStr={this.props.filterStr}
          />
        }
      >
        <Droppable droppableId={DROPPABLE_ID_FILTER}>
          {(provided, { isDraggingOver }) => (
            <div {...provided.droppableProps} ref={provided.innerRef} style={droppableStyle}>
              {filter.map((id, index) => <Dimension id={id} key={index} index={index} defaultValue={filterDefaultValues[id]} />)}
              {provided.placeholder}
              {filter.length === 0 && !isDraggingOver && (
                <CustomEmpty
                  text={t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.placeholder")}
                />
              )}
            </div>
          )}
        </Droppable>
      </Card>;

    const primaryDimCard =
      <Card
        type="inner"
        title={t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.primaryDim.title")}
        style={{ ...cardStyle }}
        bodyStyle={{ ...cardBodyStyle, minHeight: 120 }}
      >
        <Droppable droppableId={DROPPABLE_ID_PRIMARY_DIM}>
          {(provided, { isDraggingOver }) => (
            <div {...provided.droppableProps} ref={provided.innerRef} style={droppableStyle}>
              {primaryDim.map((id, index) => <Dimension id={id} key={index} index={index} isDragDisabled />)}
              {provided.placeholder}
              {primaryDim.length === 0 && !isDraggingOver && (
                <CustomEmpty
                  text={t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.placeholder")}
                />
              )}
            </div>
          )}
        </Droppable>
      </Card>;

    const secondaryCard =
      <Card
        type="inner"
        title={t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.secondaryDim.title")}
        style={{ ...cardStyle }}
        bodyStyle={{ ...cardBodyStyle, minHeight: 120 }}
      >
        <Droppable droppableId={DROPPABLE_ID_SECONDARY_DIM}>
          {(provided, { isDraggingOver }) => (
            <div {...provided.droppableProps} ref={provided.innerRef} style={droppableStyle}>
              {secondaryDim.map((id, index) => <Dimension id={id} key={index} index={index} />)}
              {provided.placeholder}
              {secondaryDim.length === 0 && !isDraggingOver && (
                <CustomEmpty
                  text={t("components.annotationsForm.layoutAnnotationDefaultChartLayout.cards.placeholder")}
                />
              )}
            </div>
          )}
        </Droppable>
      </Card>;

    return (
      <Fragment>
        {!disabled && (
          <Row type="flex" gutter={GUTTER_SM} style={{ marginBottom: MARGIN_MD }}>
            <Col>
              {t("components.annotationsForm.layoutAnnotationDefaultChartLayout.flagSaveAnnotation.title")}:
            </Col>
            <Col>
              <Checkbox
                checked={flagSaveAnnotation}
                onChange={e => this.onFlagSaveAnnotationChange(e.target.checked)}
              />
            </Col>
          </Row>
        )}
        <Row gutter={GUTTER_MD} style={{ marginBottom: MARGIN_MD }}>
          <Col span={SPAN_HALF}>
            <DragDropContext
              onDragEnd={({ source, destination }) => this.onDragEnd(source, destination)}
            >
              <Row gutter={GUTTER_MD} type="flex">
                <Col span={SPAN_HALF}>
                  {filterCard}
                </Col>
                <Col span={SPAN_HALF}>
                  <Row style={{ marginBottom: MARGIN_SM }}>
                    {primaryDimCard}
                  </Row>
                  <Row>
                    {secondaryCard}
                  </Row>
                </Col>
              </Row>
            </DragDropContext>
          </Col>
          <Col span={SPAN_HALF} style={{ display: 'flex', justifyContent: 'center' }}>
            <Radio.Group
              value={chartLayoutMode}
              onChange={({ target }) => {
                this.setState({ chartLayoutMode: target.value })
              }}
              size="small"
            >
              <Radio.Button
                value={CHART_LAYOUT_MODE.cartesian}
              >
                {t("components.annotationsForm.layoutAnnotationDefaultChartLayout.chart.cartesian.title")}
              </Radio.Button>
              <Radio.Button
                value={CHART_LAYOUT_MODE.radial}
              >
                {t("components.annotationsForm.layoutAnnotationDefaultChartLayout.chart.radial.title")}
              </Radio.Button>
            </Radio.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form className="advanced-form">
              <Form.Item
                label={t('components.annotationsForm.layoutAnnotationDefaultChartLayout.lockedDims.label')}
              >
                <Select
                  disabled={disabled}
                  value={lockedDims}
                  onChange={val => this.onLockedDimsChange(val)}
                  mode="multiple"
                >
                  {(dsdDimensions || []).map(({ id }, index) => (
                    <Select.Option
                      key={index}
                      value={id}
                      title={id}
                    >
                      {id}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default compose(
  translate(),
)(DefaultChartLayout);
